var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('veui-button',{attrs:{"ui":_vm.ui,"loading":_vm.loading},on:{"click":_vm.tap}},[_vm._v(_vm._s(_vm.text))])}
var staticRenderFns = []

export { render, staticRenderFns }